import { __assign, __rest } from "tslib";
import React from 'react';
import { View, ScrollView } from 'react-native';
import { textStyle } from '../../v2/theme';
import { PnmacUIButton, PnmacText, PnmacRow, PnmacTable, PnmacModal, PnmacHtmlToNative, PnmacCardButtonRow } from 'pnmac-universal-components';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import styles from '../../styles/styles.js';
import BankAccountGrid from "./BankAccountGrid";
import { checkForAllNumbersWBetweenMinLengthAndMaxLength, decryptBankAccountNumber, encryptBankAccountNumber, isEmptyOrSpaces } from '../../utils.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../events';
var useStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 500,
    margin: 'auto'
  },
  paper: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    margin: 20
  },
  consrm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: -10,
    marginBottom: 10
  },
  root: {
    width: '90%',
    '& > * + *': {
      marginTop: 2
    }
  }
};
export default function AddBankAccount(_a) {
  var _b, _c, _d, _e, _f, _g;
  var matches = _a.matches,
    bankAccountId = _a.bankAccountId,
    open = _a.open,
    closeModal = _a.closeModal,
    translations = _a.translations,
    setBankType = _a.setBankType,
    layout = _a.layout,
    addBank = _a.addBank,
    isOtp = _a.isOtp,
    bankAccountType = _a.bankAccountType,
    trackerDispatcher = _a.trackerDispatcher,
    rest = __rest(_a, ["matches", "bankAccountId", "open", "closeModal", "translations", "setBankType", "layout", "addBank", "isOtp", "bankAccountType", "trackerDispatcher"]);
  var _h = React.useState(false),
    addBankAccount = _h[0],
    setAddBankAccount = _h[1];
  var _j = React.useState(""),
    error = _j[0],
    setError = _j[1];
  var _k = React.useState(false),
    edit = _k[0],
    setEdit = _k[1];
  var _l = React.useState({}),
    deleteit = _l[0],
    setDeleteId = _l[1];
  var _m = React.useState({}),
    deleteAccount = _m[0],
    setDeleteAccount = _m[1];
  var _o = React.useState(false),
    bankSubmitted = _o[0],
    setBankSubmitted = _o[1];
  var _p = React.useState(true),
    canSubmitted = _p[0],
    setCanSubmitted = _p[1];
  var _q = React.useState(false),
    addBankAccountSuccess = _q[0],
    setAddBankAccountSuccess = _q[1];
  var _r = React.useState({
      "bankRoutingNumberError": false,
      "bankAccountNumberError": false,
      "confirmAccountNumberError": false,
      "bankAccountTypeError": false,
      "bankAccountNameError": false
    }),
    errors = _r[0],
    setErrors = _r[1];
  var _s = React.useState({
      "bankAccountId": bankAccountId,
      "bankRoutingNumber": "",
      "bankAccountName": "",
      "bankAccountType": bankAccountType,
      "bankAccountNumber": "",
      "loanId": (_b = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber) === null || _b === void 0 ? void 0 : _b.toString(),
      "isDraftAccount": true,
      "isDrawAccount": false,
      "isHelocAccount": false,
      "isEDisbursementAccount": false,
      "createUser": "string",
      "updateUser": "string",
      "confirmAccountNumber": "",
      "unmaskedAccountNumber": ""
    }),
    bankAccount = _s[0],
    setBankAccount = _s[1];
  var onChange = function (data, attribute) {
    var _a, _b;
    if (attribute == "bankAccountNumber") {
      setBankAccount(__assign(__assign({}, bankAccount), (_a = {}, _a[attribute] = data, _a.unmaskedAccountNumber = data, _a)));
    } else {
      if (attribute === 'bankAccountType') {
        var msg = data === 201286 ? "Checking" : "Savings";
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting ".concat(msg), 0);
      }
      setBankAccount(__assign(__assign({}, bankAccount), (_b = {}, _b[attribute] = data, _b)));
    }
  };
  var deleteBankAccountFunc = function (func) {
    if (deleteAccount.confirmAccountNumber == deleteAccount.bankAccountNumber) {
      setBankSubmitted(true);
      setError("");
      setAddBankAccountSuccess(false);
      deleteAccount.bankAccountType = deleteAccount.bankAccountType == 201286 ? 1 : 2;
      deleteAccount.bankAccountNumber = deleteAccount.unmaskedAccountNumber;
      fetch("".concat(layout.pennyHomeUrl, "api/payment/delete_bank_account_payments"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(__assign(__assign({}, deleteAccount), {
          bankAccountNumber: undefined,
          bankAccountNumberEncode: encryptBankAccountNumber(deleteAccount.unmaskedAccountNumber)
        }))
      }).then(function (res) {
        return res.text();
      }).then(function (data) {
        if (data == "true") {
          if (func) {
            func();
          }
          setAddBankAccount(false);
          setBankAccount(__assign(__assign({}, bankAccount), {
            bankRoutingNumber: "",
            bankAccountName: "",
            bankAccountType: "",
            bankAccountNumber: "",
            confirmAccountNumber: ""
          }));
          if (!func) {
            rest.getBanks(function (banks) {
              return setBankSubmitted(false);
            }, layout.selectedLoanNumber);
          }
        } else {
          setBankSubmitted(false);
        }
      });
    } else {
      setError("*Please confirm your bank account number!");
    }
  };
  var addBankAccountFunc = function () {
    var _a, _b;
    setErrors(__assign(__assign({}, errors), {
      bankRoutingNumberError: false,
      bankAccountNumberError: false,
      confirmAccountNumberError: false,
      bankAccountTypeError: false,
      bankAccountNameError: false
    }));
    if (bankAccount.confirmAccountNumber == bankAccount.bankAccountNumber) {
      if (bankAccount.bankAccountType == null) {
        setBankSubmitted(false);
        setError("Please select the valid Bank Account Type");
      } else {
        setBankSubmitted(true);
        setError("");
        setAddBankAccountSuccess(false);
        if (edit) {
          bankAccount.bankAccountType = bankAccount.bankAccountType == 201286 ? 1 : bankAccount.bankAccountType == 201287 ? 2 : null;
          bankAccount.bankAccountNumber = bankAccount.unmaskedAccountNumber;
          bankAccount.routingTransitNumber = bankAccount.bankRoutingNumber;
          deleteBankAccountFunc(function () {
            fetch("".concat(layout.pennyHomeUrl, "api/payment/add_bank_account_payments"), {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(layout.token)
              },
              body: JSON.stringify(__assign(__assign({}, bankAccount), {
                bankAccountNumber: undefined,
                bankAccountNumberEncode: encryptBankAccountNumber(bankAccount.unmaskedAccountNumber)
              }))
            }).then(function (res) {
              return res.text();
            }).then(function (data) {
              if (data == "Operation processed without any known issues.") {
                addBank(__assign(__assign({}, bankAccount), {
                  unmaskedAccountNumber: bankAccount.bankAccountNumber,
                  accountNumber: bankAccount.bankAccountNumber,
                  bankAccountType: bankAccount.bankAccountType == 1 ? 201286 : bankAccount.bankAccountType == 2 ? 201287 : null
                }));
                rest.getBanks(function (banks) {
                  setBankSubmitted(false);
                  setAddBankAccount(false);
                  setBankAccount(__assign(__assign({}, bankAccount), {
                    bankRoutingNumber: "",
                    bankAccountName: "",
                    bankAccountType: "",
                    bankAccountNumber: "",
                    confirmAccountNumber: ""
                  }));
                }, layout.selectedLoanNumber);
                setAddBankAccountSuccess(true);
              } else {
                setBankSubmitted(false);
              }
            });
          });
        } else {
          var account = (_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (s) {
            return s.unmaskedAccountNumber == bankAccount.unmaskedAccountNumber && s.routingTransitNumber == bankAccount.bankRoutingNumber;
          });
          if (account.length > 0) {
            setBankSubmitted(false);
            setError("*Bank Account details already exist. Please use a unique account number!");
          } else {
            bankAccount.bankAccountType = bankAccount.bankAccountType == 201286 ? 1 : bankAccount.bankAccountType == 201287 ? 2 : null;
            bankAccount.bankAccountNumber = bankAccount.unmaskedAccountNumber;
            bankAccount.routingTransitNumber = bankAccount.bankRoutingNumber;
            fetch("".concat(layout.pennyHomeUrl, "api/payment/add_bank_account_payments"), {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(layout.token)
              },
              body: JSON.stringify(__assign(__assign({}, bankAccount), {
                bankAccountNumber: undefined,
                bankAccountNumberEncode: encryptBankAccountNumber(bankAccount.unmaskedAccountNumber)
              }))
            }).then(function (res) {
              return res.text();
            }).then(function (data) {
              if (data == "Operation processed without any known issues.") {
                addBank(__assign(__assign({}, bankAccount), {
                  unmaskedAccountNumber: bankAccount.bankAccountNumber,
                  accountNumber: bankAccount.bankAccountNumber,
                  bankAccountType: bankAccount.bankAccountType == 1 ? 201286 : bankAccount.bankAccountType == 2 ? 201287 : null
                }));
                rest.getBanks(function (banks) {
                  setAddBankAccount(false);
                  setBankSubmitted(false);
                  setBankAccount(__assign(__assign({}, bankAccount), {
                    bankRoutingNumber: "",
                    bankAccountName: "",
                    bankAccountType: "",
                    bankAccountNumber: "",
                    confirmAccountNumber: ""
                  }));
                }, layout.selectedLoanNumber);
                setAddBankAccountSuccess(true);
              } else {
                setBankSubmitted(false);
              }
            });
          }
        }
      }
    } else {
      setError("*Please confirm your bank account number!");
    }
  };
  var Func = function (_a) {
    var _b, _c;
    var d = _a.d;
    return deleteit != d ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-around"
      }
    }, !d.canNotEdit && /*#__PURE__*/React.createElement(View, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(PnmacCardButtonRow.Button, {
      first: true,
      innerButtonStyles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 10
      },
      icon: "pencil",
      text: "Edit",
      onPress: function () {
        setBankAccount(__assign(__assign({}, bankAccount), {
          bankRoutingNumber: d.routingTransitNumber,
          bankAccountName: d.accountName,
          bankAccountType: d.bankAccountType,
          bankAccountNumber: d.accountNumber,
          confirmAccountNumber: d.accountNumber,
          bankAccountId: d.bankAccountId,
          unmaskedAccountNumber: d.unmaskedAccountNumber
        }));
        setDeleteAccount(__assign(__assign({}, bankAccount), {
          bankRoutingNumber: d.routingTransitNumber,
          bankAccountName: d.accountName,
          bankAccountType: d.bankAccountType,
          bankAccountNumber: d.accountNumber,
          confirmAccountNumber: d.accountNumber,
          bankAccountId: d.bankAccountId,
          unmaskedAccountNumber: d.unmaskedAccountNumber
        }));
        setAddBankAccount(true);
        setEdit(true);
      }
    })), ((_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.bankAccounts) === null || _c === void 0 ? void 0 : _c.length) > 1 && !d.canNotEdit && /*#__PURE__*/React.createElement(View, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(PnmacCardButtonRow.Button, {
      first: true,
      innerButtonStyles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 10
      },
      icon: "cross",
      text: "Delete",
      color: "red",
      onPress: function () {
        setDeleteAccount(__assign(__assign({}, bankAccount), {
          bankRoutingNumber: d.routingTransitNumber,
          bankAccountName: d.accountName,
          bankAccountType: d.bankAccountType,
          bankAccountNumber: d.accountNumber,
          confirmAccountNumber: d.accountNumber,
          bankAccountId: d.bankAccountId,
          unmaskedAccountNumber: d.unmaskedAccountNumber
        }));
        setDeleteId(d);
        setEdit(false);
      }
    }))) : /*#__PURE__*/React.createElement(View, {
      style: {
        fontSize: matches.small ? 10 : 14,
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription,
      idTag1: 'lblDeleteAccountConfirmMsg'
    }, "Please confirm that you will be deleting this account")), /*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
      }
    }, !layout.pennyWise && /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer",
        width: '50%',
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        return deleteBankAccountFunc();
      }
    }, "Confirm")), layout.pennyWise && /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "",
        width: '50%',
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        return deleteBankAccountFunc();
      }
    }, "Confirm")), /*#__PURE__*/React.createElement(View, {
      style: {
        cursor: "pointer",
        width: '50%',
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'outlined',
      onPress: function () {
        return setDeleteId({});
      }
    }, "Cancel"))));
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
    onBackdropPress: function () {
      return closeModal();
    },
    open: open,
    style: {
      borderRadius: 10,
      paddingBottom: 10
    }
  }, /*#__PURE__*/React.createElement(ScrollView, {
    style: __assign(__assign({}, useStyles.paper), {
      backgroundColor: "#FFF",
      maxWidth: matches.small ? "100%" : 500,
      maxHeight: "90%",
      paddingVertical: 10
    })
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblModalPopBankAccounts',
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      fontSize: matches.small ? 14 : 18
    })
  }, translations.BankAccounts)), /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, rest, {
    layout: layout,
    source: translations.NickNameBanner
  })), addBankAccountSuccess ? /*#__PURE__*/React.createElement(SuccessMessage, {
    onPress: function () {
      return setAddBankAccountSuccess(false);
    },
    message: translations.BankAccounSuccessMsg
  }) : null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountErrorMsg',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }, error)), /*#__PURE__*/React.createElement(PnmacTable, {
    style: __assign({
      backgroundColor: "#FFF",
      borderRadius: 10
    }, styles.shadowStyles),
    borderStyle: {
      borderColor: "#EFEFEF"
    }
  }, (_d = (((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.bankAccounts) || []).filter(function (s) {
    return !s.canNotEdit;
  })) === null || _d === void 0 ? void 0 : _d.map(function (d, i) {
    var _a, _b;
    return /*#__PURE__*/React.createElement(PnmacRow, {
      key: i,
      flexArr: [1, 1, 1],
      noBorder: true,
      data: deleteit != d ? [/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, 'Name '), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, d.accountName)), /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, 'Type: '), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, d.bankAccountType == 201287 ? "Saving" : "Checking"))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, translations.eDis_AccountNumber), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, d.accountNumber)), /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, 'Routing Number: '), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, d.routingTransitNumber))), /*#__PURE__*/React.createElement(Func, {
        d: d
      })] : [/*#__PURE__*/React.createElement(Func, {
        d: d
      })],
      style: {
        padding: 10,
        backgroundColor: i % 2 === 0 ? "#FFF" : "#EFEFEF",
        borderTopLeftRadius: i === 0 ? 10 : 0,
        borderTopRightRadius: i === 0 ? 10 : 0,
        borderBottomLeftRadius: i === ((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts.length) - 1 ? 10 : 0,
        borderBottomRightRadius: i === ((_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.bankAccounts.length) - 1 ? 10 : 0
      },
      textStyle: __assign(__assign({}, textStyle.defaultTextTitle), {
        padding: 10,
        fontSize: matches.small ? 12 : 14
      })
    });
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 15,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    nativeID: "btnAddBankAccount",
    mode: "contained",
    testID: "AddBankAccount",
    onPress: function () {
      setBankAccount(__assign(__assign({}, bankAccount), {
        bankRoutingNumber: "",
        bankAccountName: "",
        bankAccountType: bankAccountType,
        bankAccountNumber: "",
        confirmAccountNumber: "",
        unmaskedAccountNumber: ""
      }));
      setAddBankAccount(true);
      setAddBankAccountSuccess(false);
      setEdit(false);
    },
    disabled: ((_f = (_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.bankAccounts) === null || _f === void 0 ? void 0 : _f.length) > 4
  }, translations.AddBankAccount)), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 15,
      marginBottom: 15
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription,
    idTag1: 'lblMaxBankAccMsg1'
  }, translations.MaxBankAccMsg1)), /*#__PURE__*/React.createElement(View, {
    style: __assign({
      marginBottom: 15
    }, textStyle.defaultTextDescription)
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblMaxBankAccMsg2'
  }, translations.MaxBankAccMsg2)), addBankAccount ? /*#__PURE__*/React.createElement(BankAccountGrid, {
    errors: errors,
    disabled: true,
    isOtp: isOtp,
    layout: layout,
    matches: matches,
    setError: setError,
    setCanSubmitted: setCanSubmitted,
    translations: translations,
    bankAccount: bankAccount,
    onChange: onChange,
    setErrors: setErrors
  }) : null, addBankAccount ? /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginVertical: 30
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    nativeID: "btnAddBankAccountCancel",
    mode: "contained",
    testID: "CancelText",
    onPress: function () {
      var _a;
      setBankAccount({
        "bankRoutingNumber": "",
        "bankAccountName": "",
        "bankAccountType": bankAccountType,
        "bankAccountNumber": "",
        "loanId": (_a = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber) === null || _a === void 0 ? void 0 : _a.toString(),
        "isDraftAccount": true,
        "isDrawAccount": false,
        "isHelocAccount": false,
        "isEDisbursementAccount": false,
        "createUser": "string",
        "updateUser": "string",
        "confirmAccountNumber": ""
      });
      setAddBankAccount(false);
      setError("");
      setAddBankAccountSuccess(false);
      setErrors(__assign(__assign({}, errors), {
        bankRoutingNumberError: false,
        bankAccountNumberError: false,
        confirmAccountNumberError: false,
        bankAccountTypeError: false,
        bankAccountNameError: false
      }));
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblAddBankAccountCancel'
  }, translations.CancelText))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    nativeID: "btnAddBankAccountSubmit",
    loading: bankSubmitted,
    disabled: edit ? !(parseInt(bankAccount.bankAccountNumber) > 0 || canSubmitted) || !(bankAccount.bankAccountNumber != "") || !(bankAccount.confirmAccountNumber != "" && bankAccount.bankAccountNumber == bankAccount.confirmAccountNumber) || isEmptyOrSpaces((_g = bankAccount.bankAccountType) === null || _g === void 0 ? void 0 : _g.toString()) || isEmptyOrSpaces(bankAccount.bankAccountName) || layout.pennyWise || errors.bankRoutingNumberError : !(parseInt(bankAccount.bankAccountNumber) > 0 || canSubmitted) || !(checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount.bankAccountNumber, 5, 17) && bankAccount.bankAccountNumber != "") || !(checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount.confirmAccountNumber, 5, 17) && bankAccount.confirmAccountNumber != "" && bankAccount.bankAccountNumber == bankAccount.confirmAccountNumber) || isEmptyOrSpaces(bankAccount.bankAccountType.toString()) || isEmptyOrSpaces(bankAccount.bankAccountName) || layout.pennyWise || errors.bankRoutingNumberError,
    mode: "contained",
    testID: "SubmitText",
    onPress: function () {
      var _a, _b;
      if (isEmptyOrSpaces(bankAccount.bankRoutingNumber) || isEmptyOrSpaces(bankAccount.bankAccountNumber) || isEmptyOrSpaces(bankAccount.confirmAccountNumber) || bankAccount.bankAccountNumber != bankAccount.confirmAccountNumber || isEmptyOrSpaces((_a = bankAccount.bankAccountType) === null || _a === void 0 ? void 0 : _a.toString()) || isEmptyOrSpaces(bankAccount.bankAccountName)) {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: isEmptyOrSpaces(bankAccount.bankRoutingNumber),
          bankAccountNumberError: isEmptyOrSpaces(bankAccount.bankAccountNumber),
          confirmAccountNumberError: isEmptyOrSpaces(bankAccount.confirmAccountNumber) || bankAccount.bankAccountNumber != bankAccount.confirmAccountNumber,
          bankAccountTypeError: isEmptyOrSpaces((_b = bankAccount.bankAccountType) === null || _b === void 0 ? void 0 : _b.toString()),
          bankAccountNameError: isEmptyOrSpaces(bankAccount.bankAccountName)
        }));
      } else {
        addBankAccountFunc();
      }
    }
  }, translations.SubmitText))) : null, !addBankAccount && /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    nativeID: "btnAddBankaAccountOkButton",
    mode: "contained",
    testID: "ModalPopupOkButtonText",
    loading: bankSubmitted,
    disabled: bankSubmitted,
    onPress: function () {
      var _a;
      setBankAccount({
        "bankRoutingNumber": "",
        "bankAccountName": "",
        "bankAccountType": "",
        "bankAccountNumber": "",
        "loanId": (_a = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber) === null || _a === void 0 ? void 0 : _a.toString(),
        "isDraftAccount": true,
        "isDrawAccount": false,
        "isHelocAccount": false,
        "isEDisbursementAccount": false,
        "createUser": "string",
        "updateUser": "string",
        "confirmAccountNumber": ""
      });
      setAddBankAccount(false);
      setError("");
      setAddBankAccountSuccess(false);
      setErrors(__assign(__assign({}, errors), {
        bankRoutingNumberError: false,
        bankAccountNumberError: false,
        confirmAccountNumberError: false,
        bankAccountTypeError: false,
        bankAccountNameError: false
      }));
      closeModal();
    }
  }, translations === null || translations === void 0 ? void 0 : translations.ModalPopupOkButtonText)))));
}